import { createPrefix, createAction } from '@hokodo/core/lib/actionHelpers';

const prefix = createPrefix('session');

export const CREATE_SESSION = prefix('CREATE_SESSION');
export const createSession = createAction(CREATE_SESSION);
export const DESTROY_SESSION = prefix('DESTROY_SESSION');
export const destroySession = createAction(DESTROY_SESSION);
